import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const supplyChainRoute = createRoute({
    path: "/supplychain",
    name: "menu.supplychain",
    icon: "local_shipping",
    accCode: "",
    exclude_breadcrumbs: true,
});

export const scPointRoute = createRoute({
    path: `${supplyChainRoute.path}/point`,
    name: "menu.supplychain_point",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
});

export const scPointCreateRoute = createRoute({
    path: `${scPointRoute.path}/create`,
    name: "supplychain_distributionPoint.add",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
    action: "create",
    redirectTo: scPointRoute.path,
});

export const scPointEditRoute = createRoute({
    path: `${scPointRoute.path}/edit`,
    name: "supplychain_distributionPoint.edit",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
    action: "edit",
    redirectTo: scPointRoute.path,
});

export const scGoodsReqRoute = createRoute({
    path: `${supplyChainRoute.path}/request`,
    name: "menu.supplychain_request",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
});

export const scGoodsReqCreateRoute = createRoute({
    path: `${scGoodsReqRoute.path}/create`,
    name: "supplychain_itemReq.add",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
    action: "create",
    redirectTo: scGoodsReqRoute.path,
});

export const scGoodsReqEditRoute = createRoute({
    path: `${scGoodsReqRoute.path}/edit`,
    name: "supplychain_itemReq.edit",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
    action: "edit",
    redirectTo: scGoodsReqRoute.path,
});

export const scGoodsReqViewRoute = createRoute({
    path: `${scGoodsReqRoute.path}/view`,
    name: "supplychain_itemReq.detail",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
});

export const scGoodsReqDORoute = createRoute({
    path: `${scGoodsReqRoute.path}/do`,
    name: "supplychain_do.",
    accCode: "",
    parentCode: supplyChainRoute.accCode,
});

// component
const Supplychain = lazy(() => import("../page/supplychain/Supplychain"));
const ScItemRequest = lazy(() => import("../page/supplychain/item_request/ItemRequest"));
const ScItemRequestView = lazy(() => import("../page/supplychain/item_request/view/ItemRequestView"));
const ScItemRequestForm = lazy(() => import("../page/supplychain/item_request/form/ItemRequestForm"));
const ScItemRequestDOForm = lazy(() => import("../page/supplychain/do/SupplychainDOForm"));

const ScDistributionPoint = lazy(() => import("../page/supplychain/distribution_point/DistributionPoint"));
const ScDistributionPointForm = lazy(() => import("../page/supplychain/distribution_point/DistributionPointForm"));

export const supplychainListRoutes = [scPointRoute, scGoodsReqRoute];
export const scMutationRoutes = [
    scPointCreateRoute, scPointEditRoute, scGoodsReqDORoute,
    scGoodsReqCreateRoute, scGoodsReqEditRoute, scGoodsReqViewRoute
];

export const supplyChainRoutes = {
    element: <Supplychain />,
    children: addHandleRoute([
        { ...scPointRoute, element: <ScDistributionPoint /> },
        { ...scPointCreateRoute, element: <ScDistributionPointForm type="add" /> },
        { ...scPointEditRoute, element: <ScDistributionPointForm type="edit" /> },
        { ...scGoodsReqRoute, element: <ScItemRequest /> },
        { ...scGoodsReqCreateRoute, element: <ScItemRequestForm type="add" /> },
        { ...scGoodsReqEditRoute, element: <ScItemRequestForm type="edit" /> },
        { ...scGoodsReqViewRoute, element: <ScItemRequestView /> },
        { ...scGoodsReqDORoute, element: <ScItemRequestDOForm /> },
    ]),
};
